import {
  store,
  easingFormulas,
  Entity,
  coreEngine,
  configs,
} from "@dinahmoe/dmafjs-core";

import { softKnee } from "../utils/knee";

class Scaler extends Entity {
  namespace = "control:scaler";
  handlers = {
    "value.in": this.scale,
  };

  init(node, event) {
    // TODO remove props where not needed, make private props with underscore
    if (node["scaling.dataId"]) {
      node["scaling.breakpoints"] = store.get("assets.data." + node["scaling.dataId"]);
    }

    if (!node["scaling.breakpoints"] || node["scaling.breakpoints"].length === 0) {
      return;
    }

    node._breakpoints = node["scaling.breakpoints"].map((breakpoint) =>
      configs.resolveConfig(breakpoint, event)
    );

    node.lastValueIn = null;
    node.lastValueOut = null;

    this.checkSortOrder(node.uid, node._breakpoints);

    node.min = node._breakpoints[0].valueIn;
    node.max = node._breakpoints[node._breakpoints.length - 1].valueIn;
    node["scaling.range"] = node.max - node.min;
    node.minScaled = node._breakpoints[0].valueOut;
    node.maxScaled = node._breakpoints[node._breakpoints.length - 1].valueOut;

    // TODO activate soft knee

    //node.soft = softKnee.softFunctionFactory(
    //  node._breakpoints.map((breakpoint) => [
    //    breakpoint.valueIn,
    //    breakpoint.valueOut,
    //  ]),
    //  node.range
    //);

    this.scale(node, node.min);
  }

  checkSortOrder(uid, array) {
    for (var i = 0; i < array.length - 1; i++) {
      if (array[i].valueIn > array[i + 1].valueIn) {
      }
    }
  }

  getRangeIndex(array, value) {
    for (var i = 0; i < array.length; i++) {
      if (value < array[i].valueIn) {
        return i - 1;
      }
    }
  }

  scale(node, value) {
    let usedVal = node.props["value.in"];
    if (typeof value === "number") {
      usedVal = value;
    }

    if (!node._breakpoints || node._breakpoints.length === 0) {
      // an error has already been shows for this
      return;
    }

    usedVal = usedVal - node.props["value.offset"];

    usedVal = this.getValueInBounds(node, usedVal);

    if (usedVal === node.lastValueIn) {
      // value was equal to this.lastValueIn. Ignore
      return;
    }

    const scaledValue = this.calculateScaledValue(node, usedVal);

    if (scaledValue !== node.lastValueOut) {

      if(node["target.property"]) {
        const targetProperty = node["target.property"];
        const dotIndex = targetProperty.indexOf(".");
        const uid = targetProperty.slice(0, dotIndex);
        const propertyName = targetProperty.slice(dotIndex + 1);
        coreEngine.update({
          uid: uid,
          key: propertyName,
          value: scaledValue,
        });
      } else {
        coreEngine.update({
          uid: node.uid,
          key: "value.out",
          value: scaledValue,
        });
      }


      node.lastValueOut = scaledValue;
    }
  }

  getValueInBounds(node, value) {
    if (!node.props["scaling.wrap"]) {
      return value;
    }

    if (value > node.max) {
      return node.max;
    }

    if (value < node.min) {
      return node.min;
    }

    return value;
  }

  calculateScaledValue(node, value) {
    if (value <= node.min) {
      const scaledValue = node.minScaled;
      node.lastValueIn = node.min;

      return scaledValue;
    }

    if (value >= node.max) {
      const scaledValue = node.maxScaled;
      node.lastValueIn = node.max;

      return scaledValue;
    }

    const index = this.getRangeIndex(node._breakpoints, value);
    const lowerBp = node._breakpoints[index];
    lowerBp.easing ??= "LINEAR";

    const upperBp = node._breakpoints[index + 1];
    const scaledValue = this.scaleValue(value, lowerBp, upperBp);

    node.lastValueIn = value;
    return scaledValue;
  }

  scaleValue(value, lowerBp, upperBp) {
    // TODO doesn't work
    // always returns soft value
    //
    //if (lowerBp.easing === "LINEAR" && this.range !== 0) {
    //  return this.soft(value);
    //}

    const easing = easingFormulas[lowerBp.easing];
    const normalized = this.normalize(value, lowerBp, upperBp);

    return (
      easing(normalized, lowerBp.curve) *
        (upperBp.valueOut - lowerBp.valueOut) +
      lowerBp.valueOut
    );
  }

  normalize(value, lowerBp, upperBp) {
    const normalized =
      (value - lowerBp.valueIn) / (upperBp.valueIn - lowerBp.valueIn);

    if (normalized > 1) {
      return 1;
    }
    if (normalized < 0) {
      return 0;
    }

    return normalized;
  }
}

const scaler = new Scaler();
export { scaler, Scaler };
